import { Tab, Tabs, Typography } from '@material-ui/core';
import { FuncaoParticipante, GrupoAcesso, ParticipanteResponse, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import SuspensaoHistorico, { SuspensaoHistoricoKind } from 'components/suspensaoHistorico';
import { Button, LgSpace, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { RootState } from 'store';
import Documentos from './documentos';
import InformacoesPrincipais from './informacoesPrincipais';
import { initialParticipante } from './initialParticipante';
import RepresentantesLegais from './representantesLegais';
import UsuarioMaster from './usuarioMaster';
import Historico from './historico';
import ConsultaCaf from './consultaCaf';
import ServicosFinanceiros from './servicosFinanceiros';
import FundosDepositados from './fundosDepositados';

type ComponentParams = { participanteId: string, filtro?: string };
type ComponentState = { initialTab?: number };
type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const DetalhesParticipante: React.FC<Props> = (props) => {
  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [participante, setParticipante] = useState<ParticipanteResponse>(initialParticipante);
  const [filtro, setFiltro] = useState<any>();
  const history = useHistory();

  const dispatch = useDispatch();
  const getParticipanteApi = useSelector((state: RootState) => state.participanteApi.getParticipante);
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;

  const isAdministradorFiduciario = useMemo(() =>
    participante?.funcoes?.some((pf) => pf.funcao === FuncaoParticipante.AdministradorFiduciario) ?? false,
  [participante]);

  const getParticipante = useCallback(async () => {
    try {
      const result = await getParticipanteApi(dispatch, props.match.params.participanteId, true);
      setParticipante(result);
    } catch {}
  }, [dispatch, getParticipanteApi, props.match.params.participanteId]);

  useEffect(() => {
    if (props.match.params.filtro) {
      setFiltro(props.match.params.filtro);
    }
    getParticipante();
  }, [props.match.params.filtro, getParticipante]);

  const backToParticipantesPage = () => {
    const filtroJson = JSON.parse(filtro);
    return history.push(`/solicitacoes/filtro/${JSON.stringify(filtroJson)}`, { initialTab: 1 });    
  };
 
  return (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{'Participante'}</Typography>
      <SmSpace />

      {props.match.params.filtro && 
      <Button onClick={backToParticipantesPage} variant="contained" color="primary">
        {'Voltar para a página anterior'}
      </Button>
      }

      <LgSpace />
      {(() => {
        const cafTabIndex = isUsuarioOperacoes ? 6 : -1;
        const servicosTabIndex = isUsuarioOperacoes ? 7 : 6;
        const fundosTabIndex = isAdministradorFiduciario ? (isUsuarioOperacoes ? 8 : 7) : -1;

        return (
          <>
            <HorizontalAppBar>
              <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
                <Tab label="Informações Principais" />
                <Tab label="Representantes Legais" />
                <Tab label="Usuários" />
                <Tab label="Documentos" />
                <Tab label="Suspensões" />
                <Tab label="Histórico" />
                {isUsuarioOperacoes && <Tab label="Detalhes da Consulta (CAF)" />}
                <Tab label="Serviços Financeiros Laqus" />
                {isAdministradorFiduciario && <Tab label="Fundos depositados" />}
              </Tabs>
            </HorizontalAppBar>
            {tabValue === 0 && <InformacoesPrincipais informacoesPrincipais={participante} />}
            {tabValue === 1 && <RepresentantesLegais representantesLegais={participante} />}
            {tabValue === 2 &&
              participante.usuarios.map((usuario, index) => {
                return <UsuarioMaster usuarioMaster={usuario} key={index} />;
              })}
            {tabValue === 3 && <Documentos participante={participante} />}
            {tabValue === 4 && (
              <SuspensaoHistorico
                kind={SuspensaoHistoricoKind.Participante}
                registroHistoricos={participante.registro.registroHistoricos}
              />
            )}
            {tabValue === 5 && <Historico participante={participante} />}
            {tabValue === cafTabIndex && isUsuarioOperacoes && <ConsultaCaf participante={participante} />}
            {tabValue === fundosTabIndex && isAdministradorFiduciario && (
              <FundosDepositados administradorFiduciarioId={participante.id} />
            )}
            {tabValue === servicosTabIndex && <ServicosFinanceiros informacoesBancarias={participante} />}
          </>
        );
      })()}
      <LgSpace />
    </div>
  );
};

export default DetalhesParticipante;
